import '../../CommonStyles.scss';
import KpiCard from '../../components/KpiCard/KpiCard';
import { KpiMeta } from '../../components/KpiCard/KpiMeta';
import { NoData } from '../../components/NoData/NoData';
import { useGetWebinarsSummary } from 'queryHooks/analytics';
import { YoutubeViewsBreakdown } from '../../components/YoutubeViewsBreakdown/YoutubeViewsBreakdown';
import { getLatestDayData } from 'utilities/getLatestDayData';
import { ViewsPerWebinarChartCard } from '../../components/ViewsPerWebinarChart/ViewsPerWebinarChart';
import { ViewsDistributionChartCard } from '../../components/ViewsDistributionChart/ViewsDistributionChart';

export const WebinarsTab = () => {
  const { data: webinarsSummary, isLoading: webinarsLoading, isError: webinarsError } = useGetWebinarsSummary();

  const latestDayData = getLatestDayData(webinarsSummary || [], 'date');
  const getTotalViewsForLatestDay = () => latestDayData.reduce((sum, v) => sum + v.views, 0);

  const getTopWebinar = () => latestDayData.sort((a, b) => b.views - a.views)[0];
  const topWebinar = latestDayData.length ? getTopWebinar() : null;

  return (
    <div className='analytics-tab'>
      {webinarsError || webinarsLoading || !webinarsSummary?.length ? (
        <NoData loading={webinarsLoading} error={webinarsError} noData={!webinarsSummary?.length} />
      ) : (
        <>
          <div className='overview-section'>
            <div className='section-grid metrics'>
              <KpiCard label='Total webinars' source='YOUTUBE' value={new Set(webinarsSummary.map((v) => v.videoId)).size} />
              <KpiCard label='Total views' source='YOUTUBE' value={getTotalViewsForLatestDay()} />
              {topWebinar && (
                <KpiCard label='Top webinar' source='YOUTUBE' value={topWebinar.title} customClasses='top-webinar-card'>
                  <KpiMeta>{topWebinar.views.toLocaleString()} views</KpiMeta>
                </KpiCard>
              )}
            </div>
          </div>

          <div className='overview-section'>
            <div className='section-grid trends'>
              <ViewsPerWebinarChartCard />
              <ViewsDistributionChartCard />
            </div>
          </div>

          <div className='overview-section'>
            <YoutubeViewsBreakdown />
          </div>
        </>
      )}
    </div>
  );
};
